
<!-- <div> -->
	<vue-apple-login
		mode="logo-only"
		type="sign in"
		color="black"
		:border="false"
		logoSize="medium"
		className="dp_inline"
		:onSuccess="onSuccess"
		:onFailure="onFailure"
	></vue-apple-login>
<!-- </div> -->
